var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98418 4.03128C9.79318 1.83428 7.50118 0.756283 7.40418 0.712283C7.3135 0.669657 7.21188 0.656038 7.11318 0.673283C4.46718 1.11228 4.06918 2.65228 4.05318 2.71628C4.03141 2.80547 4.03487 2.89895 4.06318 2.98628C7.21918 12.7783 13.7782 14.5933 15.9342 15.1903C16.1002 15.2363 16.2372 15.2733 16.3412 15.3073C16.4599 15.3461 16.5888 15.3386 16.7022 15.2863C16.7682 15.2563 18.3262 14.5223 18.7072 12.1283C18.7241 12.0238 18.7073 11.9166 18.6592 11.8223C18.6252 11.7563 17.8102 10.2053 15.5502 9.65728C15.4735 9.63767 15.3932 9.63699 15.3162 9.65528C15.2392 9.67357 15.1678 9.71029 15.1082 9.76228C14.3952 10.3713 13.4102 11.0203 12.9852 11.0873C10.1362 9.69428 8.54518 7.02128 8.48518 6.51428C8.45018 6.22928 9.10318 5.22828 9.85418 4.41428C9.90138 4.36305 9.93733 4.30251 9.95972 4.23655C9.98211 4.17058 9.99044 4.10066 9.98418 4.03128Z",
    fill: "url(#paint0_linear_3095_255)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3095_255",
    x1: 11.3763,
    y1: 0.666016,
    x2: 11.3763,
    y2: 15.3318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4944"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationCall);
export default __webpack_public_path__ + "static/media/location-call.98f4dbdc9320500d88c61295dec05f11.svg";
export { ForwardRef as ReactComponent };